import React from 'react';
import { useEffect, useState } from "react";
import Select from 'react-select';
import { getAllData, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../_actions/loader.actions";

const Rolerights = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [userrolerights, setUserRoleRights] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [roleId, setRoleId] = useState(0)
    const [toggleAdmin, setToggleRowAdmin] = useState([]);
    const user = useSelector(store => store.userstatus.tba);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);
    const [savedata, setDataSave] = useState({
        RoleId: 0,
        UserRolesRightsList: [],
        UserType: 0
    })
    const handleExpandAdmin = (e) => {
        const doesExist = toggleAdmin.includes(e);
        if (doesExist === false) {
            setToggleRowAdmin(current => [...current, e]);
        }
        else {
            setToggleRowAdmin((oldState) => oldState?.filter((item) => item !== e));

        }
    }
    const getRoleList = async () => {
        await getAllData('/auth/v1/bindroleslist?UserType=' + 0).then((roledata) => {
            setRoleList(roledata.data?.map((el) => ({
                label: el.label,
                value: el.value
            })))
        })
    }
    const getUserRoleRigths = async () => {
        await getAllData('/auth/v1/binduserrolerights?UserType=' + 0).then((userdata) => {
            setUserRoleRights(userdata.data);
        })
    }
    const getRoleById = async () => {
        setUserRoleRights([]);
        const roleid = roleId;
        await getAllData('/auth/v1/getusereoledetailbyrole?roleid=' + roleid + '&UserType=' + 0).then((roledata) => {
            setUserRoleRights(roledata.data);
            setDataSave({ ...savedata, RoleId: roleId, UserRolesRightsList: roledata.data })
            dispatch(loaderActions.end());
        })
        let pagelink = user?.find(x => {
            if (x.PageLink === window.location.pathname)
                return x.MenuId
        });
        let mid = user?.find(x => x.MenuId === pagelink.MenuId);
        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate('/dashboard');
        }
        user?.filter(x => x.MenuId === pagelink.MenuId).map((obj) => {
            setUserAdd(obj.URightAdd);
            setUserEdit(obj.URightEdit);
            setUserExport(obj.URightExport);

        });
    }
    const handleRolechange = (e) => {
        setRoleId(e.value);
    }
    useEffect(() => {
        setUserRoleRights([]);
        dispatch(loaderActions.start());
        getRoleById();
    }, [roleId])


    const handlesavadata = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            let status = false;
            let data = false;
            const UserData = await postUsersData("/auth/v1/insertorupdaterolesrights", savedata);
            status = UserData.status;
            data = UserData.data;
            if ((!status && data === null) || (!status && !data)) {
                dispatch({ type: 'ALERTING', message: UserData.message })
                return;
            }
            else {
                if (status && data > 0) {
                    dispatch({ type: 'ALERTING', message: UserData.message })
                    handleClearClick();
                }
                else {
                    dispatch({ type: 'ALERTING', message: UserData.message })
                    handleClearClick();
                    return;
                }
            }
        }

    }
    const handleChangeCheck = (e, menuId) => {
        if (roleId == 0) {
            // dispatch(alertActions.error('please select Role'));
        }
        else {
            let Vuserroledetail = userrolerights;
            let Rights = Vuserroledetail.filter((t) => t.Menu_Id === menuId);
            if (e.target.value === "All") {
                if (e.target.checked) {
                    Rights[0].uRoleAll = true;
                    Rights[0].uRoleView = true;
                    Rights[0].uRoleExport = true;
                    Rights[0].uRoleAdd = true;
                    Rights[0].uRoleEdit = true;
                }
                else {
                    Rights[0].uRoleAll = false;
                    Rights[0].uRoleView = false;
                    Rights[0].uRoleExport = false;
                    Rights[0].uRoleAdd = false;
                    Rights[0].uRoleEdit = false;
                }
            }

            else if (e.target.value === "Add") {
                Rights[0].uRoleAdd = Rights[0].uRoleAdd === true ? false : true;
            }
            else if (e.target.value === "Edit") {
                Rights[0].uRoleEdit = Rights[0].uRoleEdit === true ? false : true;
            }
            else if (e.target.value === "View") {
                Rights[0].uRoleView = Rights[0].uRoleView === true ? false : true;
            }
            else if (e.target.value === "Export") {
                Rights[0].uRoleExport = Rights[0].uRoleExport === true ? false : true;
            }
            if (Rights[0].uRoleView === true && Rights[0].uRoleExport === true && Rights[0].uRoleAdd === true && Rights[0].uRoleEdit === true) {
                Rights[0].uRoleAll = true;
            }
            if (Rights[0].uRoleView != true) {
                Rights[0].uRoleView = Rights[0].uRoleExport || Rights[0].uRoleAdd || Rights[0].uRoleEdit;
            }
            if (!Rights[0].uRoleView || !Rights[0].uRoleExport || !Rights[0].uRoleAdd || !Rights[0].uRoleEdit) {
                Rights[0].uRoleAll = false;
            }
            let fnlUserRight = Vuserroledetail.map((user) => {
                if (user.Menu_Id == menuId) {
                    return Rights[0];
                }
                return user;
            })
            Vuserroledetail = fnlUserRight;
            setUserRoleRights(Vuserroledetail);
            setDataSave({ ...savedata, RoleId: roleId, UserRolesRightsList: Vuserroledetail })

        }
    }

    const handleClearClick = () => {
        setRoleId(0);
    }
    
    useEffect(() => {
        getUserRoleRigths();
        getRoleList();
    }, []);

    return (
        <>
            <div className="container-fluid mt-4 heading_color">
                <h3>Role Rights</h3>
            </div>
            <div className="container-fluid form_border pt-5 my-3">
                <form action="" >
                    <div className="mb-3 row mx-1">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="row">
                                <div className='col-md-6 mb-lg-1'>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <label for="inputPassword6" className="col-form-label required">Select Role</label>
                                        </div>
                                        <div className=" col-lg-8 col-md-12 col-sm-12">
                                            <Select className="dropdown select_dropdown"
                                                options={roleList}
                                                value={roleList?.filter(function (roleList) {
                                                    return roleList.value === roleId;
                                                })}
                                                onChange={handleRolechange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mb-3 row">
                        <div className='overflow-auto'>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className='ps-4' scope="col">Title</th>
                                        <th scope="col">All</th>
                                        <th scope="col">View</th>
                                        <th scope="col">Add</th>
                                        <th scope="col">Edit</th>
                                        <th scope="col">Export</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {userrolerights && userrolerights?.map((el) => {
                                        return (
                                            <>
                                                {
                                                    (el.MenuType === 0 && el.PageTitle === "Dashboard") ?
                                                        <>
                                                            <tr>
                                                                <th className='ps-4' width="275px" scope="row">{el.PageTitle}</th>
                                                                <td><input className="form-check-input" checked={el.uRoleAll} name='All' onChange={(e) => handleChangeCheck(e, el.Menu_Id)} type='checkbox' value="All" /></td>
                                                                <td><input className="form-check-input" checked={el.uRoleView} name='el.PageTitle' onChange={(e) => handleChangeCheck(e, el.Menu_Id)} type='checkbox' value="View" /></td>
                                                                <td><input className="form-check-input" checked={el.uRoleAdd} name='el.PageTitle' onChange={(e) => handleChangeCheck(e, el.Menu_Id)} type='checkbox' value="Add" /></td>
                                                                <td><input className="form-check-input" checked={el.uRoleEdit} name='el.PageTitle' onChange={(e) => handleChangeCheck(e, el.Menu_Id)} type='checkbox' value="Edit" /></td>
                                                                <td><input className="form-check-input" checked={el.uRoleExport} name='el.PageTitle' onChange={(e) => handleChangeCheck(e, el.Menu_Id)} type='checkbox' value="Export" /></td>
                                                            </tr>
                                                        </> : ''
                                                }
                                                {
                                                    (el.MenuType === 1) ?
                                                        <>
                                                            <tr>
                                                                <th className='admin_btn' width="275px" onClick={() => handleExpandAdmin(el.ParentId)} scope="row"><i className={`fa fa-angle-down me-1 ${toggleAdmin.filter((val1) => (val1 === el.ParentId))?.map((val) => val === el.ParentId ? 'rotet' : '')}`} aria-hidden="true"></i>{el.PageTitle}</th>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                            </tr>
                                                        </> : ''
                                                }
                                                {toggleAdmin.filter((val1) => (val1 === el.ParentId))?.map((val) => {
                                                    return (
                                                        (el.MenuType === 0) ?
                                                            <>
                                                                <tr>
                                                                    <th className='ps-4' width="275px" scope="row">{el.PageTitle}</th>
                                                                    <td><input className="form-check-input" checked={el.uRoleAll} name='All' onChange={(e) => handleChangeCheck(e, el.Menu_Id)} type='checkbox' value="All" /></td>
                                                                    <td><input className="form-check-input" checked={el.uRoleView} name='el.PageTitle' onChange={(e) => handleChangeCheck(e, el.Menu_Id)} type='checkbox' value="View" /></td>
                                                                    <td><input className="form-check-input" checked={el.uRoleAdd} name='el.PageTitle' onChange={(e) => handleChangeCheck(e, el.Menu_Id)} type='checkbox' value="Add" /></td>
                                                                    <td><input className="form-check-input" checked={el.uRoleEdit} name='el.PageTitle' onChange={(e) => handleChangeCheck(e, el.Menu_Id)} type='checkbox' value="Edit" /></td>
                                                                    <td><input className="form-check-input" checked={el.uRoleExport} name='el.PageTitle' onChange={(e) => handleChangeCheck(e, el.Menu_Id)} type='checkbox' value="Export" /></td>
                                                                </tr>
                                                            </> : ''
                                                    )
                                                })}

                                            </>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center mb-4">
                        {(useradd === true || useredit === true) ?
                            <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handlesavadata} disabled={roleId > 0 ? false : true} >Save</button>
                            :
                            <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handlesavadata} disabled={true} >Save</button>}
                        <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={handleClearClick}>Clear</button>
                    </div>
                </form >
            </div >
        </>
    )
}

export default Rolerights